/**
 * Highly experimental, the name might change.
 */
export const unstable_allowServer = <T>(x: T) => x;

export { ErrorBoundary } from './lib/components/ErrorBoundary.js';
